// API의 Base URL을 설정
const DEV = 'http://glucofit-raffle-api-dev.lansik.us:11213';
const PROD = 'https://glucofit-raffle-api.lansik.us';
const API_BASE_URL = PROD;

// 다른 모듈에서 사용할 수 있도록 내보냄
export { API_BASE_URL };
